<form *ngIf="taxFormGroup" [formGroup]="taxFormGroup">
    <p-card class="p-3" header="Datos generales"> 
        <div class="grid">
            <div class="col input-field">
                <label for="name">Nombre *</label>
                <input pInputText formControlName="name" d-form-field-error />
            </div>            
            <div class="col input-field">
                <label for="name">Porcentaje *</label>
                <input formControlName="percent" pInputText type="number" d-form-field-error>
            </div>   
            <div class="col-2 input-field">
                <label for="active" class="mr-1">Activo</label>
                <div class="flex h-full">
                  <p-inputSwitch id="active" name="active" formControlName="active" d-form-field-error></p-inputSwitch>
                </div>
              </div>         
              <div class="col-2 input-field">
                <label for="default" class="mr-1">Por defecto</label>
                <div class="flex h-full">
                  <p-inputSwitch id="default" name="default" formControlName="default" d-form-field-error></p-inputSwitch>
                </div>
              </div>         
        </div>

        <div class="mt-4 flex gap-2 justify-content-end">
            <p-button label="Eliminar" *ngIf="allowDelete" icon="pi pi-trash" styleClass="p-button-danger"
                (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
    </p-card>
</form>
<p-confirmDialog></p-confirmDialog>